import React from 'react';

const SubmissionSuccess = ({ formData }) => {
  return (
    <div className="text-center">
      <h1>Thank you, {formData.name}!</h1>
      <p>Your message has been sent successfully.</p>
      <p><strong>Email:</strong> {formData.email}</p>
      <p><strong>Message:</strong> {formData.message}</p>
    </div>
  );
};

export default SubmissionSuccess;
